import { ReactSVG } from 'react-svg';
import Container from '../../components/Container';
import icons from '../../constants/icons';
import { Text } from '../../components/SecondaryMarket';
import SubmitApplicationFunctional from './index.function';
import { fontSizes } from '../../constants/constants';
import { useSelector } from 'react-redux';
import { getContentKeyAccToLang } from '../../utils/utils';
import { useSearchParams } from 'react-router';

const SubmitApplication = () => {
  const [searchParams] = useSearchParams();
  const { TextWeight, isArabic, handleLogout } = SubmitApplicationFunctional();

  const corpAOContent = useSelector((state) => state.content?.corpAOContent);
  const applicationId = searchParams.get('applicationId')

  const getContentKey = (key) => {
    return getContentKeyAccToLang(corpAOContent?.submit_application?.data?.attributes, key, isArabic)
  }

  return (
    <Container handleLogout={handleLogout} title={getContentKey('institutions_account_invester')} isBack={false} isPublic={true}>
      <div className='bg-white shadow-light-shadow rounded-xl flex-1 px-6 py-10 flex flex-col items-center justify-center'>
        <ReactSVG src={icons.success_check} />

        <Text
          text={getContentKey('submitted')}
          weight={TextWeight.headingRegular}
          size={fontSizes.h30}
          className={'text-dark-blue mt-6 mb-3'}
          align={'text-center'}
        />
        <Text
          text={getContentKey("account_opening_request")}
          size={fontSizes.h14}
          className={'w-full md:w-1/2 lg:w-1/3'}
          align={'text-center'}
        />

        <div className='bg-light-blue/10 mt-5 py-2 px-5 rounded-full'>
          <Text
            text={`${getContentKey("application_no")} ${applicationId || 0}`}
            weight={TextWeight.bold}
            className={'text-light-blue'}
          />
        </div>
      </div>
    </Container>
  );
};

export default SubmitApplication;
